
import Room from './Room.js'

export default class Maze
{
  constructor({width=10, height=10})
  {
    this.m_width = width;          
    this.m_height = height;         

    this.m_rooms = [];            // empty array of rooms to start
  }


  getWidth()
  {
    return this.m_width;
  }


  getHeight()
  {
    return this.m_height;
  }


  getTotalRooms()
  {
    return this.m_rooms.length;
  }


  getRoomsArray()
  {
    //returns the unfiltered rooms array
    return this.m_rooms;
  }


  getRoomAt(xCoord, yCoord)
  {
    if (xCoord < 0 || xCoord >= this.m_width)
    {
      //xCoord is not valid
      return 0;
    }

    if (yCoord < 0 || yCoord >= this.m_height)
    {
      // yCoord is not valid 
      return 0;
    }

    //calc index into array for room
    let roomIndex = xCoord + (this.m_width * yCoord)

    if (roomIndex >= 0 && roomIndex < this.m_rooms.length)
    { 
      //double checking that we have a valid room index
      return this.m_rooms[roomIndex];
    }

    //if we got this far, there is an error
    return 0; 
  }


  //build out the basic rooms for the maze (no walls torn down yet)
  buildRooms()
  {
    let totalRooms = this.m_width * this.m_height;
    if (totalRooms > 0 && totalRooms < 20000)         //sanity check so we dont make a crazy sized maze room count
    {
      for (let i = 0; i < totalRooms; i++)
      {
        let tempRoom = new Room({});
        this.m_rooms.push(tempRoom);
      }
    }
  }


};
